// extracted by mini-css-extract-plugin
export var pillWrapper = "_ji-0";
export var showOverflow = "_ji-1";